// extracted by mini-css-extract-plugin
export var inlineLink = "_7x-0";
export var inlineLinkButton = "_7x-1";